import { supabase } from "../../lib/supabase";
import { Tables } from "../../integrations/supabase/types";

export type Thought = Tables<"thoughts">;

export async function getThoughts() {
  const { data, error } = await supabase
    .from("thoughts")
    .select("*")
    .order("created_at", { ascending: false });

  if (error) throw error;
  return data;
}

export async function getThought(id: string) {
  const { data, error } = await supabase
    .from("thoughts")
    .select("*")
    .eq("id", id)
    .single();

  if (error) throw error;
  return data;
}

export async function updateThought(id: string, updates: Partial<Thought>) {
  const { error } = await supabase
    .from("thoughts")
    .update(updates)
    .eq("id", id);

  if (error) throw error;
}

export async function saveThought(thought: Partial<Thought> & { user_id: string }) {
  const { error } = await supabase
    .from("thoughts")
    .insert(thought);

  if (error) throw error;
}

export async function deleteThought(id: string) {
  const { error } = await supabase
    .from("thoughts")
    .delete()
    .eq("id", id);

  if (error) throw error;
}
